import { useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import "../styles/ClinicalAuditReviewForm.css";
import { Preview, Info } from "@mui/icons-material";
import { toast } from "react-toastify";
import Modal from "react-modal";
import { usePopper } from "react-popper";
// import HTMLReactParser from 'html-react-parser';
// import { createPortal } from 'react-dom';

function ToolTipClinicalAuditReviewForm({ information, pos, widthTo = "" }) {
  const [isOpen, setIsOpen] = useState(false);

  //     <div>
  //       <button onClick={() => setIsOpen(true)}>Open Modal</button>
  //       <Modal
  //         isOpen={isOpen}
  //         onRequestClose={() => setIsOpen(false)}
  //         contentLabel="Modal"
  //       >
  //         <h2>{information}</h2>
  //         <button onClick={() => setIsOpen(false)}>Close Modal</button>
  //       </Modal>
  //     </div>
  //   );
  // };
  const [showTooltip, setShowTooltip] = useState(false);
  const [iconPosition, setIconPosition] = useState({ top: 0, left: 0 });
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [referenceElement, setReferenceElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);
  const [arrowElement, setArrowElement] = useState(null);
  // const [isOpen, setIsOpen] = useState(false);

  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    modifiers: [
      { name: "arrow", options: { element: arrowElement } },
      {
        name: "offset",
        options: { offset: [information.length > 200 ? 250 : 150, 0] },
      },
    ],
  });

  console.log("----------", styles);
  const handleIconClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const updateIconPosition = () => {
    const icon = document.querySelector(".info-icon-active");
    console.log(icon);
    if (icon) {
      const rect = icon.getBoundingClientRect();
      console.log(rect);
      setIconPosition({
        top: rect.top + window.scrollY,
        left: rect.left + window.scrollX,
      });
    }
  };

  //useEffect(()=>{
  //    updateIconPosition()
  //     // const handleResizeAndScroll = () => {
  //     //     updateIconPosition();
  //     //   };
  //     //     // Attach event listeners for resize and scroll
  //     //     window.addEventListener('resize', handleResizeAndScroll);
  //     //     window.addEventListener('scroll', handleResizeAndScroll);

  //     //     // Cleanup: Remove event listeners when the component unmounts
  //     //     return () => {
  //     //       window.removeEventListener('resize', handleResizeAndScroll);
  //     //       window.removeEventListener('scroll', handleResizeAndScroll);
  //     //     };
  //     const portalContainer = document.createElement('div');
  //     portalContainer.id = 'popup-root';
  //     document.body.appendChild(portalContainer);

  //},[])

  //   const handleIconClick = () => {
  //     // Show a toast popup
  //     //updateIconPosition();
  //     toast.info(`${information}`, {
  //       position: toast.POSITION.TOP_LEFT,
  //       autoClose: false, // Adjust the duration as needed
  //     });

  //   };
  const popperStyles = {
    ...styles.popper,
    width:
      information.length > 200 ? (widthTo !== "" ? widthTo : "490px") : "310px",
    left: "15px",

    zIndex: 100,

    // transform: `translate3d('300px', 0, 0)`,
    // Add more styles as needed
  };

  console.log(
    popperStyles,
    "--->",
    information.length > 200 ? (widthTo !== "" ? widthTo : "500px") : "300px"
  );
  const portalContainer = useRef(document.createElement("div"));

  useEffect(() => {
    document.body.appendChild(portalContainer.current);

    return () => {
      document.body.removeChild(portalContainer.current);
    };
  }, []);

  return (
    <>
      <div className="info-icon-container">
        <div
          style={{
            // height:'3px',

            position: pos ? pos : "",
          }}
          className={`info-icon ${showTooltip ? "info-icon-active" : ""}`}
          // onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
          onClick={() => {
            //   handleIconClick();

            setIsOpen(!isOpen);
            setShowTooltip((prevValue) => !prevValue);
          }}
        >
          <Info
            ref={setReferenceElement}
            style={{
              height: "15px",
              color: "#FB4E0B",
              // border:'orange',
              // backgroundColor:'white',
            }}
          />
          {/* &#9432; */}
        </div>
        {showTooltip &&
          createPortal(
            <div
              className="info-tooltip-right"
              ref={setPopperElement}
              // style={{ ...styles.popper, zIndex: 100, position: 'absolute',}}
              style={{
                ...popperStyles,
              }}
              {...attributes.popper}
            >
              {/* <div ref={setArrowElement} style={styles.arrow}  /> */}
              {/* {HTMLReactParser(information)}   */}
              <div ref={setArrowElement} style={styles.arrow} />
              <div
                style={{
                  width:
                    information.length > 200
                      ? widthTo != ""
                        ? widthTo
                        : "470px"
                      : "300px",
                }}
                dangerouslySetInnerHTML={{ __html: information }}
              ></div>
            </div>,

            portalContainer.current
          )}
        {/* {showTooltip &&
       <div className="info-tooltip-right"  >{information}</div> */}
        {/* <div className="info-tooltip-right"  > */}
      </div>
    </>
  );
}

export default ToolTipClinicalAuditReviewForm;
